<template>
  <div id="page-home">
    <section class="bg-color-white position-relative py-3 py-sm-5 shadow home-header">
      <div class="container d-flex justify-content-between align-items-center">
        <a href="https://www.werkgeluk.nl" title="Werk & Geluk" class="d-flex">
          <img src="https://www.werkgeluk.nl/wp-content/themes/drigro/styleguide//assets/dist/img/logo-color.svg" alt="Werk &amp; geluk" width="290" height="52" class="logo-img">
        </a>
        <a class="btn btn-small btn-color-01" href="https://www.werkgeluk.nl/over/">Contact</a>
      </div>
    </section>

    <section class="pt-0 pt-lg-15 mb-3">
      <div class="container position-relative">
        <div class="row">
          <div class="intro col-12 col-lg-5 mt-5 mt-lg-0 mb-3 mb-lg-5">
            <h1 class="text-color-white">Hoe werkgelukkig ben jij?</h1>
            <p class="text-color-white">Ben je tevreden over je baan? Ga jij elke dag met plezier naar je werk toe? Heb je het gevoel dat je werk ertoe doet?<br><br>We denken steeds meer na over ons werk. Logisch. Je brengt immers veel tijd door op je werk en dan mag het best een beetje leuk zijn toch?<br><br>Doe de test en kom erachter welk cijfer jouw werkgeluk krijgt.  </p>
            <router-link :to="{ name: 'Quiz'}" class="btn btn-color-darkblue to-quiz mt-0 mt-sm-5">Start de test</router-link>
          </div>
          <div class="col-12 col-lg-6 offset-lg-1 mt-5 mt-lg-0">
            <div class="bg-color-white shadow p-5 p-md-7 rounded">
              <p class="">Doe de test en ontdek in 2 minuten:</p>
              <ul class="checklist checklist--green">
                <li>Welk cijfer jouw werkgeluk krijgt.</li>
                <li>Tips om jouw werkgeluk te vergroten.</li>
                <li>Hoe je blijft werken aan je persoonlijke ontwikkeling.</li>
                <li>Hoe je jouw passie vindt.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>
<script>
import projects from '../../data/projects.json'
import GenerateHTML from "./GenerateHTML.vue";

export default {
  name: 'Home',
  components: {
    GenerateHTML
  },
  data() {
    return {
      label: null,
      home: []
    }
  },
  methods: {
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === 'addClass') {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
  },
  mounted() {
    fetch(projects[0]['test']['settings'] + '?v=' + Date.now()).then(r => r.json()).then(json => {
      this.home = json[0]['home'][0];
    });
    this.toggleBodyClass('addClass', 'page-home');
    this.toggleBodyClass('addClass', 'bg-color-01');
  },
  destroyed() {
    this.toggleBodyClass('removeClass', 'page-home');
    this.toggleBodyClass('removeClass', 'bg-color-01');
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue